"use strict";

module.exports = require("./index").default;